import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './permission'
import './style/reset.scss'
import './icons' // icon

Vue.config.productionTip = false

Vue.use(ElementUI, { size: 'large' })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
